import { render, staticRenderFns } from "./TabModeratorPlayerBook.vue?vue&type=template&id=fd8d95a2&"
import script from "./TabModeratorPlayerBook.vue?vue&type=script&lang=js&"
export * from "./TabModeratorPlayerBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports